<template>
    <div v-scroll="handleScroll" >
        <product :class="['col-sm-3 col.md-4 col-xs-12 col-lg-2 col-6 up','product-'+ n]"   
        v-for="(st,n) in sorted" 
        :product="st" 
        :key="st.id" 
        :scroll="scroll"
            
        />
    </div>
            
  
</template>

<script>
import Vue from 'vue';

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})
    import Product from './Product.vue'
    import { mapState} from 'vuex'

    export default {
        props:['limit'],
        name: 'Products',
        components: {
            Product,
        },
        data() {
            return {
                data: null,
                sortBy:null,
                id:null, 
                fixed:0,
                scroll:0             
            }
        },
        computed : {
            ...mapState(['sliderFilter','filterCat','stock',
            'orderPrice','orderAvailable','orderQuantity','sorted']),
            
        },
        methods: {
             handleScroll: function () {
                this.scroll=window.scrollY
                if (window.scrollY > 80) {
                    this.fixed=1
                }else{
                    this.fixed=0
                }
                
            },
            filterBy(product,n = 1) {
                var flag = true
                if(this.filterCat) {
                    flag = product.idcategoria == this.filterCat
                } 
                if(!(product.precio_venta <= this.sliderFilter[1] && product.precio_venta >= this.sliderFilter[0])) {
                    flag = false
                }
                if(!product.condicion && this.available){
                    flag = false
                }
                if(product.stock > this.stock){
                    flag = false
                }
                
                if(this.limit <=  n ){
                    flag = false
                }
                
                return flag
            },
            
            
        },
        mounted() {
            this.id=this.$route.params.id
        }
    }
</script>

<style>
.products{
    flex-direction: row;
}
.products .up{
    padding: 5px 5px;
    margin: 10px 10px;
    box-shadow:0 0 0.3rem rgba(0, 0, 0, 0.25) !important;
}
.title-producto{
    margin-bottom: 0;
    font-size: 18px;
}
.productinfo figure{
    margin:0;
}
.datos-producto{
    font-size: 12px;
}

</style>